import React from 'react';
import { IApprovalRecordStatus, getIn18Text } from 'api';
import styles from './index.module.scss';
import { TongyongChehuiMian, TongyongChenggongMian, TongyongGuanbiMian, TongyongJianshaoMian } from '@sirius/icons';
export const APPROVAL_CONFIG = {
    [IApprovalRecordStatus.approved]: {
        style: {
            color: '#398E80',
            backgroundColor: '#D6F7F1',
            border: '1px solid #D6F7F1',
        },
        icon: React.createElement(TongyongChenggongMian, { wrapClassName: "wmzz", wrapStyle: { color: '#4C6AFF' } }),
        label: getIn18Text('SHENPI') + getIn18Text('TONGGUO'),
    },
    [IApprovalRecordStatus.processing]: {
        style: {
            color: '#4759B2',
            backgroundColor: '#DEEBFD',
            border: '1px solid #DEEBFD',
        },
        label: getIn18Text('SHENPIZHONG'),
    },
    [IApprovalRecordStatus.rejected]: {
        style: {
            color: '#CB493D',
            backgroundColor: '#FFE5E2',
            border: '1px solid #FFE5E2',
        },
        icon: React.createElement(TongyongGuanbiMian, { wrapClassName: "wmzz", wrapStyle: { color: '#FE5B4C' } }),
        label: getIn18Text('BEIBOHUI'),
    },
    [IApprovalRecordStatus.recalled]: {
        style: {
            color: '#4E5A70',
            backgroundColor: '#E7EBF1',
            border: '1px solid #E7EBF1',
        },
        icon: React.createElement(TongyongChehuiMian, { wrapClassName: "wmzz", wrapStyle: { color: '#6F7485' } }),
        label: getIn18Text('YICHEHUI'),
    },
    [IApprovalRecordStatus.revoked]: {
        style: {
            color: '#4E5A70',
            backgroundColor: '#E7EBF1',
            border: '1px solid #E7EBF1',
        },
        icon: React.createElement(TongyongJianshaoMian, { wrapClassName: "wmzz", wrapStyle: { color: '#6F7485' } }),
        label: getIn18Text('YIZUOFEI'),
    },
};
const ApprovalStateTag = ({ state }) => {
    const config = state ? APPROVAL_CONFIG[state] : null;
    if (!config) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.approvalStateTag, style: config.style }, config.label));
};
export default ApprovalStateTag;
